import {take, range, partial} from 'lodash'
import Fade from '@mui/material/Fade'
import moment from 'moment'
import React from 'react'
import Text from 'react-text'
import {useDrop} from 'react-dnd'
import {Consumer} from '../../context'
import {reschedulePlan} from '../../context/post'
import Toolbar, {changeView} from './toolbar'
import Label from '../label'
import Event from './event'
import './week.styl'
import { newPlan } from 'planning/navigation'

const minEventHeight = 110
const minEventWidth = 130

const dayTitleHeight = 40
const eventHeight = 40
const horizontalMargin = 40 
const viewMoreHeight = 20
const verticalMargin = 237
const groupWidth = 200
const groupStyle = {with: groupWidth, maxWidth: groupWidth, minWidth: groupWidth}

function Day (props) {
  const {date, daySize, group, goToDay, defaultDate, lastDay} = props
  const day = moment(date).format('YYYY-MM-DD')
  const isToday = moment(date).isSame(new Date(), 'day')
  const canAdd = moment(date).isSameOrAfter(new Date(), 'day')
  const className=`day ${isToday ? 'current' : ''}`
  const displayCount = Math.floor((daySize.height - dayTitleHeight - viewMoreHeight) / eventHeight)
  const [collectedProps, drop] = useDrop({
    accept: 'event',
    canDrop: () => {
      return moment(date).isSameOrAfter(new Date(), 'day')
    },
    drop: ({id}) => {
      const event = props.context.plans.find(e => e.id == id)
      if (event) {
        const start = moment(date.toDate())
        const duration = Math.ceil(moment.duration(moment(event.finish).diff(moment(event.start))).asDays())
        const finish = moment(start).add(duration, 'days')
        reschedulePlan(id, start, finish).then(() => {
          const planUpdates = props.context.planUpdates + 1
          props.context.setState({planUpdates})
        })
      }
    }
  })
  return (<Consumer>{ context => {
    const events = (context.plansByDay[day] || [])
      .filter(event => event.clique == group.id)
    return (
      <div
        ref={drop}
        className={className}
        style={lastDay ? daySize : {
          ...daySize, maxWidth: 'none', flexGrow: 1
        }}
        onClick={() => { goToDay({group: group.id, start: day, end: day}) }}
      >

        {/* <Fade in={context.plansUpdated}> */}
          <div className="events">
            {take(events, displayCount).map((props, i) => (<Event key={i} {...{...props, day, date, defaultDate}}/>))}
          </div>
        {/* </Fade> */}
        <div style={{flexGrow: 1}} />
        <div className="view-more">
          {events.length > displayCount && (<span className="more-button">
            <Text id="view-more" /> {events.length - displayCount}...
          </span>)}
          <span style={{flexGrow: 1}} />
          {canAdd && <span className="add-plan" onClick={e => {
            e.stopPropagation()
            const suggestedDate = moment(date).toISOString()
            const suggestedGroup = group.id
            newPlan(context,  suggestedDate, suggestedGroup)
          }}>+</span>}
        </div>
      </div>
    )
  }}</Consumer>)
}

function Week(props) {
  const {start, daySize, context, group, goToDay, defaultDate} = props 
  const days = range(7)
    .map(d => ({goToDay, group, context, daySize, date: moment(start).add(d, 'days')}))
    .map((props,i) => (<Day key={i} defaultDate={defaultDate} {...props} lastDay={i == 6} />))
  const subjectId = group.course.substring(0,2)
  const subject = context.subjects.find(subject => subject.id == subjectId)

  return (
    <div className="week">
      <div className="group" style={groupStyle}>
        <div className="color-band" style={{backgroundColor: subject.color}}/>
        <div className="title">
          <div className="subject">
            {`${group.subject} - ${group.grade}`}
          </div>
          <div className="name">
            {group.name}
          </div>
        </div>
      </div>
      {days}
    </div>
  )
}

function Header(props) {
  const {date, daySize} = props
  return (
    <div
      className="header day"
      style={{width: daySize.width}}
    >
      {date.format('ddd DD/MM')}
   </div>)
}



export default function WeekView (props) {

  const {date} = props
  const start = date().startOf('week')
  const end = date().endOf('week')

  return (<Consumer>{ context => {
    const {sizes, groups, query} = context
    const goToDay = partial(changeView(context, props.view, {...query}), 'day')
    const dayWidth = Math.round((sizes.width - horizontalMargin - groupWidth - 12) / 7)
    const daySize = {
      width: dayWidth, maxWidth: dayWidth, minWidth: dayWidth,
      height: Math.max(minEventHeight, Math.round((sizes.height - verticalMargin) / groups.length))
    }

    const weeks = groups
      .filter(group => !query.group || query.group == group.id)
      .map(group => ({goToDay, context, group, start, daySize}))
      .map((props,i) => (<Week key={i} defaultDate={date} {...props}/>))

    const headers = range(7)
      .map(d => ({date: moment(start).add(d, 'days'), daySize}))
      .map((props,i) => (<Header key={i} {...props}/>))

    return (
      <div className="planning week view" style={{width: sizes.width - horizontalMargin}}>
        <Toolbar {...props} />
        <div className="calendar">
          <div className="headers">
            <div className="header groups" style={groupStyle}>
              <Text id="groups_label" />
            </div>
            {headers}
          </div>
          <div className="weeks">
            {weeks}
          </div>
        </div>
      </div>
    )}}</Consumer>)
}
